import React, { useState, useEffect } from 'react';
import { Button, Modal, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const CartModal = ({ alert, total, onCancel, hideExtraButtons = false }) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation(['cart', 'alert']);
  const history = useHistory();

  /* Up exactly while there is something to say. It used to be raised and never
     lowered, so an alert that went while the modal was open - and it does go,
     because starting any load clears it - left an empty box on screen with no
     status, no title and nothing to read, until something put an alert back.
     The recovery refetch after a refused submit does exactly that, so the
     refusal appeared, blanked for the length of the round trip, and came back. */
  useEffect(() => {
    setVisible(!!alert);
  }, [alert]);

  const onModalClose = ({ redirect }) => {
    setVisible(false);
    onCancel();
    if (redirect) history.push('/cart');
  };

  return (
    <Modal centered visible={visible} onCancel={onModalClose} footer={null}>
      <Result
        status={alert?.type}
        /* Interpolated only when there is something to interpolate: a missing
           message made the key `alert:undefined`, which i18next has nothing for
           and hands back as the literal word "undefined" for the client to read.

           No `keySeparator: false` here, however tempting - a refusal the API
           wrote reaches this lookup as a key it will not find, and i18next puts
           the key back together with whatever the separator is. Handed `false`
           it joins with it, so a message with a colon in it came back to the
           client with the word "false" sitting in the middle of the sentence. */
        title={alert?.message ? t(`alert:${alert.message}`, { total }) : ''}
        subTitle={alert?.subtitle ? t(`cart:${alert?.subtitle}`) : ''}
        extra={
          alert?.type === 'success' &&
          !hideExtraButtons && (
            <React.Fragment>
              <Button key="shop" onClick={onModalClose}>
                {t('cart:continue shopping')}
              </Button>
              <Button type="primary" key="cart" onClick={() => onModalClose({ redirect: true })}>
                {t('cart:go to cart')}
              </Button>
            </React.Fragment>
          )
        }
      />
    </Modal>
  );
};

export default CartModal;
